module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDYwIDYwIj4KICAgIDxwYXRoIGZpbGw9IiMzNDJENTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQ1LjkxIDE2LjIxMWwtMi4xMjItMi4xMjFMMzAgMjcuODc5IDE2LjIxIDE0LjA5bC0yLjEyIDIuMTIxTDI3Ljg3OCAzMCAxNC4wOSA0My43ODhsMi4xMiAyLjEyMkwzMCAzMi4xMiA0My43ODggNDUuOTFsMi4xMjEtMi4xMjEtMTMuNzg4LTEzLjc5IDEzLjc4OC0xMy43ODh6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icon-close-btn-m.svg
// module id = aJbi
// module chunks = 18